import Method from "./method";
import Guide from "./guide";
import Info from "./infor";
import Note from "./note";
import Products from "./products";
import Submit from "./submit";

const Order = () => {
   return (
      <div className="layout-orders-livestream">
         <div className="header-shop-name">
            <span>Giỏ hàng</span>
         </div>
         <div>
            <div className="line"></div>
            <Guide />
            <Products />
            <div className="end-page"></div>
            <Info />
            <div className="end-page"></div>
            <Note />
            <div className="end-page"></div>
            <Method />
         </div>
         <Submit />
      </div>
   )
}
export default Order;